export function getEnumKeyByEnumValue<T extends { [index: string]: string }>(myEnum: T, enumValue: string): keyof T | undefined {
  const key = Object.keys(myEnum).find(x => myEnum[x] == enumValue);
  if (!key)
    return undefined

  return myEnum[key];
}